<template>
    <div class="mainRight pageContainer flexCloumn"
        style="overflow-y:auto;padding-top:0;background-color:#fff;padding-right:10px;">

        <div style="width:100%;">
            <el-form :model="companyInfo" :rules="rules" ref="companyInfo" label-width="100px">
                <el-row v-if="isEdit">
                    <el-col :span="12" class="enter_form">
                        <el-form-item label="单位名称:">
                            {{ companyInfo.firm_name ? companyInfo.firm_name : "-" }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="enter_form">
                        <el-form-item label="单位性质:" prop="info">{{ qyxz[companyInfo.info] ?
                            qyxz[companyInfo.info].param_desc :
                            (companyInfo.tyc && companyInfo.tyc.enter_type ? companyInfo.tyc.enter_type : '-') }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="enter_form">
                        <el-form-item label="单位法人:">
                            {{ companyInfo.legal_person ? companyInfo.legal_person :
                            (companyInfo.tyc && companyInfo.tyc.tyc_json ? companyInfo.tyc.tyc_json.legalPersonName :
                            "-") }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="enter_form">
                        <el-form-item label="单位电话:" class="is-required">
                            <el-input class="input_css" v-model="companyInfo.co_tel" placeholder="请输入单位电话"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="enter_form">
                        <el-form-item label="联 系 人:">
                            {{ companyInfo.firm_principal }}
                            <!-- <el-input class="input_css" v-model="companyInfo.firm_principal"
                                placeholder="请输入联 系 人"></el-input> -->
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="enter_form">
                        <el-form-item label="联系方式:">
                            {{ companyInfo.tel }}
                            <!-- <el-input class="input_css" v-model="companyInfo.tel" placeholder="请输入联系方式"></el-input> -->
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="enter_form">

                        <el-form-item label="考察报告:" prop="enter_desc" class="is-required" style="margin-bottom:0;">
                            <div style="line-height:40px;color:#909399;font-size:14px;">
                                考察报告 应包含：单位资质、诚信状况、管理水平、实习岗位性质和内容、工作时间、工作环境、生活环境以及健康保障、安全防护等内容</div>

                            <el-input class="input_css" type="textarea"
                                placeholder="应包含：单位资质、诚信状况、管理水平、实习岗位性质和内容、工作时间、工作环境、生活环境以及健康保障、安全防护等内容" maxlength="1500"
                                show-word-limit rows="10" v-model="companyInfo.research_report"></el-input>
                        </el-form-item>

                        <el-form-item class="" label="上传图片">
                            <div style="color:#909399;font-size:14px;">备注：请上传天眼查截图信息/企业信用评价信息。</div>
                            <div style="display:inline-block; margin-right:10px;vertical-align: top; position: relative;"
                                v-for="(img, idx) in companyInfo.fieldname" :key="idx">
                                <el-image style="width: 100px; height: 100px" :src="img.fileUrl || img.src"
                                    :preview-src-list="[img.fileUrl || img.src]" img="cover" fit="cover"></el-image>

                                <div class="imgremove" @click="removeImg(idx)"><i class="el-icon-remove"></i></div>
                            </div>

                            <div style="display:inline-block;vertical-align: top;">

                                <el-upload style="display: inline-block; margin-right: 20px" action=""
                                    :http-request="uploadOss" :on-success="uploadFiles" :show-file-list="false"
                                    name="image" accept="image/png, image/jpeg">
                                    <div class="imgaddbtn">
                                        ＋
                                    </div>
                                </el-upload>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="!isEdit">
                    <el-col :span="12" class="enter_form">
                        <el-form-item label="单位名称:">
                            {{ companyInfo.firm_name ? companyInfo.firm_name : "-" }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="enter_form">
                        <el-form-item label="单位性质:" prop="info">{{ qyxz[companyInfo.info] ?
                            qyxz[companyInfo.info].param_desc :
                            (companyInfo.tyc && companyInfo.tyc.enter_type ? companyInfo.tyc.enter_type : '-') }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="enter_form">
                        <el-form-item label="单位法人:">
                            {{ companyInfo.legal_person ? companyInfo.legal_person :
                            (companyInfo.tyc && companyInfo.tyc.tyc_json ? companyInfo.tyc.tyc_json.legalPersonName :
                            "-") }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="enter_form">
                        <el-form-item label="单位电话:" class="">{{ companyInfo.co_tel }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="enter_form">
                        <el-form-item label="联 系 人:">
                            {{ companyInfo.firm_principal }}
                            <!-- <el-input class="input_css" v-model="companyInfo.firm_principal"
                                placeholder="请输入联 系 人"></el-input> -->
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="enter_form">
                        <el-form-item label="联系方式:">
                            {{ companyInfo.tel }}
                            <!-- <el-input class="input_css" v-model="companyInfo.tel" placeholder="请输入联系方式"></el-input> -->
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="enter_form">

                        <el-form-item label="考察报告:" prop="enter_desc" class="" style="margin-bottom:0;">
                            <div style="line-height:40px;color:#909399;font-size:14px;">
                                考察报告 应包含：单位资质、诚信状况、管理水平、实习岗位性质和内容、工作时间、工作环境、生活环境以及健康保障、安全防护等内容</div>

                            <el-input disabled class="input_css" type="textarea"
                                placeholder="应包含：单位资质、诚信状况、管理水平、实习岗位性质和内容、工作时间、工作环境、生活环境以及健康保障、安全防护等内容" maxlength="1500"
                                show-word-limit rows="10" v-model="companyInfo.research_report"></el-input>
                        </el-form-item>

                        <el-form-item v-if="companyInfo.fieldname && companyInfo.fieldname.length>0" class=""
                            label="上传图片">
                            <div style="color:#909399;font-size:14px;">备注：请上传天眼查截图信息/企业信用评价信息。</div>
                            <div style="display:inline-block; margin-right:10px;vertical-align: top; position: relative;"
                                v-for="(img, idx) in companyInfo.fieldname" :key="idx">
                                <el-image style="width: 100px; height: 100px" :src="img.fileUrl || img.src"
                                    :preview-src-list="[img.fileUrl || img.src]" img="cover" fit="cover"></el-image>
                            </div>
                        </el-form-item>

                    </el-col>
                </el-row>
                <div class="flexCenter" style="margin-top:20px;">
                    <el-button v-if="isEdit" @click="submit('companyInfo')" type="primary">提交</el-button>
                    <el-button v-if="!isEdit" @click="onModify('companyInfo')" type="success">编辑</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>

export default {
    components: {},
    data() {
        var validateEnterDesc = (rule, value, callback) => {
            if (value.trim() === "") {
                callback(new Error("请填写考察报告!"));
            } else {
                callback();
            }
        };
        return {
            companyInfo: {
                firm_name: "",
                firm_num: "",
                info: "",
                industry_id: "",
                area_name: "",
                address: "",
                enter_desc: "",
                license_imge: "",
                firm_principal: "",
                tel: "",
                email: "",
                email_status: "",
                check_status: "",
                fieldname: [],

            },
            form: {
                firm_principal: "",
                tel: "",
                email: ""
            },
            qyxz: [],
            unitSize: {},
            options: [],
            cityOptions: [],
            edit: false,
            ccstatus: false,
            rules: {
                enter_desc: [{ validator: validateEnterDesc, trigger: "blur" }],
            },
            isEdit:false,
        };
    },
    mounted() {
        this.$http
            .post("/api/zp_industry_tree", { pmid: window.pmid })
            .then(res => {
                if (res && res.data && res.data.tree) {
                    this.options = res.data.tree;
                }
            });
        this.getEnterInfo();
        this.getComType();
    },
    methods: {
        getComType() {
            return new Promise(resolve => {
                this.$http
                    .post("/api/sys_param_list", {
                        param_type: "'ENTER_INFO','UNIT_SIZE'",
                        used: 0
                    })
                    .then(res => {
                        let qyxz = [];
                        let unitSize = {}
                        for (let item of res.data) {
                            if (item.param_type == "ENTER_INFO") {
                                qyxz.push(item);
                            }
                            if (item.param_type == "UNIT_SIZE") {
                                unitSize[item.param_value] = item.param_desc;
                            }
                        }
                        this.qyxz = qyxz;
                        this.unitSize = unitSize
                        resolve();
                    });
            });
        },
        getEnterInfo() {
            this.$http.post("/api/enterprise_info", {}).then(res => {
                if (res.data.research_fieldname && this.isJSON(res.data.research_fieldname)) {
                    res.data.fieldname = JSON.parse(res.data.research_fieldname)
                } else {
                    res.data.fieldname = []
                    }
                      this.companyInfo = res.data;
                this.companyInfo.industry_id = Number(res.data.industry_id);
                this.companyInfo.info = res.data.info + "";
                if (res.data.research_report) {
                    this.isEdit = false
                } else {
                    this.isEdit = true
                }
                
            });
        },
              uploadFiles(e) {
            this.companyInfo.fieldname.push(e)
        },
        removeImg(idx) {
            this.companyInfo.fieldname.splice(idx, 1)
        },
     
        submit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (!this.companyInfo.research_report) {
                        this.$message.warning('请填写考察报告')
                        return
                    }
                    this.$http
                        .post("/api/enterprise_research_report_update", {
                            co_tel: this.companyInfo.co_tel,
                            research_report: this.companyInfo.research_report,
                            research_fieldname: JSON.stringify(this.companyInfo.fieldname)
                        })
                        .then(res => {
                            this.$message.success('保存成功！')
                            this.getEnterInfo();
                            // setTimeout(() => {
                            //     window.location.reload()
                            // }, 500);
                        });
                    this.ccstatus = false;
                } else {
                    return false;
                }
            });
        },
        onModify() {
            this.isEdit = true
        }
    }
};
</script>

<style lang="less" type="text/less" scoped>
.pageContainer {
    box-sizing: border-box;

    div,
    h3,
    p {
        box-sizing: border-box;
    }
}

.license_imge_css {
    background-color: #fafafa;
    border: 1px dashed #d9d9d9;
    width: 181px;
    height: 256px;
    float: right;
    margin-right: 25px;
}

.input_css {
   /* width: 430px;*/
}

.companyInfo {
    background-color: #ffffff;
    font-size: 14px;
    color: #303133;
    position: relative;

    .baseInfo {
        position: relative;
        z-index: 1;
    }

    .ant-alert-success {
        width: 508px;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        z-index: 99;

        /deep/ .ant-alert-message {
            display: none;
        }

        p {
            margin-bottom: 0;
        }
    }

    .state-pic {
        width: 160px;
        position: absolute;
        right: 32px;
        top: 20px;
    }

    .fail {
        width: 60%;
        margin: 0 0 0 30px;
        background-color: #fff1f0;
        border: 1px solid #ffa39e;
        border-radius: 4px;
        padding: 5px 10px;
        max-width: 50%;

        .anticon-close-circle {
            margin-right: 5px;
        }

        span {
            color: #1890ff;
            cursor: pointer;
            float: right;
        }
    }

    h3 {
        font-size: 16px;
        height: 62px;
        line-height: 62px;
        font-weight: bold;
        margin-bottom: 0;
        padding: 0 30px;

        p {
            border-bottom: 1px solid #e6e7eb;

            em {
                font-size: 14px;
                color: #909399;
                font-style: normal;
                font-weight: normal;
            }

            span {
                float: right;
                color: #909399;
                font-weight: normal;
                font-size: 14px;

                .anticon-form {
                    color: #3378fa;
                    margin-right: 5px;
                    cursor: pointer;
                }
            }
        }
    }

    ul {
        padding: 0;
        width: 90%;
        padding: 0 30px 30px;
        margin-bottom: 0;
        position: relative;
        z-index: 1;

        li {
            list-style: none;
            margin-top: 16px;
            line-height: 24px;

            b {
                display: block;
                width: 160px;
                float: left;
                color: #909399;
                font-weight: normal;
                text-align: right;
            }

            span {
                display: block;
                margin-left: 100px;

                img {
                    max-width: 100%;
                }
            }
        }
    }

    /deep/ .ant-form {
        background-color: #f6f8fc;
        padding: 24px 30px;

        .ant-form-item {
            width: 50%;

            label {
                color: #909399;
            }
        }

        .btnItem {
            display: flex;
            justify-content: flex-end;

            .cancel {
                margin-right: 10px;
            }
        }
    }
}

.imgaddbtn {
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border: 1px dotted #ccc;
    font-size: 30px;
    cursor: pointer;
}

.imgremove {
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;

    cursor: pointer;
    position: absolute;
    top: -5px;
    right: -5px;
    color: #ccc;
}

.imgremove:hover {
    color: orange;
}

@media screen and (max-width: 1000px) {
    .companyInfo ul {
        width: 100%;
    }
}
</style>
